import React from "react";
import { Message, toaster } from "rsuite";
import ArticleDto from "../interfaces/articleDto";

const api = process.env.REACT_APP_API_URL ?? "http://localhost:8080";

export const getAllArticles = async (
  page: number,
  limit: number,
  query?: string,
  sortType?: string,
  sortColumn?: string
) => {
  return await fetch(
    `${api}/api/articles?page=${page - 1}&size=${limit}${
      query !== "" && query !== undefined ? `&query=${query}` : ""
    }${
      sortType !== undefined &&
      sortType !== null &&
      sortColumn !== undefined &&
      sortColumn !== null
        ? `&sort[${sortColumn}]=${sortType}`
        : ""
    }
    `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};

export const createArticle = async (body: ArticleDto) => {
  return await fetch(`${api}/api/articles/createArticle`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        toaster.push(
          <Message showIcon type='success' header='Erfolgreich'>
            Der Artikel {data.name} wurde erfolgreich gespeichert.
          </Message>
        );
      }
    })
    .catch((e) => {
      console.log(e);
      toaster.push(
        <Message showIcon type='error' header='Fehlgeschlagen'>
          Leider ist beim Speichern des Artikels etwas schiefgelaufen.
        </Message>
      );
      return;
    });
};

export const updateArticle = async (id: number, body: ArticleDto) => {
  try {
    const article = await fetch(`${api}/api/articles/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(body),
    });

    if (article.ok) {
      const data = await article.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der User {data.name} wurde erfolgreich gespeichert.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Speichern des Users etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};

export const deleteArticle = async (id: number) => {
  try {
    const deleteArticle = await fetch(`${api}/api/articles/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    });
    if (deleteArticle.ok) {
      const data = await deleteArticle.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der Article {data.name} wurde erfolgreich gelöscht.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Löschen des Articles etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};
